import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { storeAuthData } from "@/utils/auth";
import { landingAfterSignIn } from "@/utils/todays-tips-ready";

/**
 * Auth Callback Page
 *
 * Route: /auth/callback?token=...&customerId=...&email=...&redirect=...
 *
 * Receives auth data from portal subdomain via URL params,
 * stores it in localStorage/sessionStorage, then redirects.
 * This enables cross-subdomain authentication.
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    const customerId = searchParams.get("customerId") || "";
    const email = searchParams.get("email") || "";
    const phone = searchParams.get("phone") || "";
    const onboarding = searchParams.get("onboarding") === "1";
    const redirect = searchParams.get("redirect") || "/todays-tips";

    if (!token) {
      // No token, redirect to login
      window.location.href = "/login";
      return;
    }

    // Store authentication data
    storeAuthData(customerId, email, phone, token, 24, onboarding);

    // Redirect to the target page (/home instead of /todays-tips until today's tips are out)
    let cancelled = false;
    landingAfterSignIn(redirect).then((target) => {
      if (!cancelled) window.location.href = target;
    });
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  // Minimal loading UI while processing
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F5F5F5]">
      <div className="w-16 h-16 bg-[#FCEDF7] rounded-full flex items-center justify-center mb-4">
        <div className="w-12 h-12 border-4 border-transparent border-t-[#F0A7D6] rounded-full animate-spin"></div>
      </div>
      <p className="text-gray-600">Setting up your session...</p>
    </div>
  );
}
